import React, { useState } from "react";
import "../../../styles/TablesSBoardType1.css";
import { BoardProps, InputRoundType1 } from "../../types/types";
import normalizeWord from "./utils/normalizeWord";
import { useGame } from "../../../GameContext";
import { useTimerActions } from "../../../TimerContext";

import createTableType1 from "./utils/createTable1";
import getCode from "./utils/getcode";
import shuffleArray from "../shuffleArray";

import RenderBoardLogo from "../RenderBoardLogo";
import RenderCode from "./RenderCode";
import RenderTable1 from "./RenderTable1";
import RenderGameCard from "../RenderGameCard";

import MESSAGES from "../message";

const BoardType1: React.FC<BoardProps> = ({ random, rounds,type }) => {
  const { setMessage, setGuessesWords, setGameStarted, isGameStarted } =
    useGame();

  const { startTimer, stopTimer, resetTimer } = useTimerActions();

  const roundsData = rounds as InputRoundType1[];

  const words = roundsData[0].words.map((word) => word.toUpperCase());

  const sizeTable = roundsData[0].size;

  // состояние для отслеживания, завершена ли игра
  const [isGameFinished, setIsGameFinished] = useState<boolean>(false);

  // состояние для хранения введенного пользователем ответа
  const [answerValue, setAnswerValue] = useState<string>("");

  const [blockUserInput, setBlockUserInput] = useState<boolean>(true);

  // состояние ответа на проверку отгадки
  const [answerStatus, setAnswerStatus] = useState<
    "idle" | "correct" | "wrong"
  >("idle");
  // номер текущей загадки внутри таблицы
  const [wordIndex, setWordIndex] = useState(0);

  const createWordOrder = () => {
    const indexes = words.map((_, index) => index);
    return random ? shuffleArray(indexes) : indexes;
  };

  const [order, setOrder] = useState(createWordOrder);

  // Получаем текущее слово для проверки
  const currentWord = words[order[wordIndex]];

  const isLastPuzzle = wordIndex === order.length - 1;

  // Создаем таблицу для текущей загадки
  const [table] = useState(() => createTableType1(words, sizeTable));

  const code = getCode(currentWord, table);

  const startRound = () => {
    setAnswerValue("");
    setAnswerStatus("idle");
    setBlockUserInput(false);

    setMessage(MESSAGES.START);
    startTimer();
  };

  const finishRound = () => {
    stopTimer();
    setBlockUserInput(true);
  };

  const restartGame = () => {
    resetTimer();

    setGuessesWords([]);
    setOrder(createWordOrder());

    setWordIndex(0);
    setIsGameFinished(false);

    startRound();
  };

  const handleStart = () => {
    setGameStarted(true);
    restartGame();
  };

  const nextGuessed = () => {
    if (isGameFinished) {
      restartGame();
      return;
    }

    setWordIndex((prev) => prev + 1);
    startRound();
  };

  const checkAnswer = (value: string) => {
    if (isGameFinished || !isGameStarted || blockUserInput) return;
    const answer = normalizeWord(value);

    if (!answer) {
      setMessage(MESSAGES.ENTER_ANSWER);
      setAnswerStatus("wrong");
      return;
    }

    if (normalizeWord(value) !== normalizeWord(currentWord)) {
      setMessage(MESSAGES.ANSWER_WRONG);
      setAnswerStatus("wrong");
      return;
    }

    setAnswerStatus("correct");
    setGuessesWords((prev) => [...prev, normalizeWord(currentWord)]);

    finishRound();

    if (isLastPuzzle) {
      setIsGameFinished(true);
      setMessage(MESSAGES.GAME_FINISHED);
    } else {
      setMessage(MESSAGES.ROUND_FINISHED);
    }
  };
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAnswerValue(e.target.value);

    if (answerStatus === "wrong") {
      setAnswerStatus("idle");
    }
  };

  const handleInputKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key !== "Enter" || e.repeat) return;

    e.preventDefault();

    checkAnswer(answerValue);

    e.currentTarget.blur();
  };
  return (
    <div className="tableS-Board">
      <div className="tableS-board-content">
        {/* Логотип с кнопками и таймером */}
        <RenderBoardLogo
          isGameStarted={isGameStarted}
          isGameFinished={isGameFinished}
          onNext={nextGuessed}
          onStart={handleStart}
          type = {type}
        />

        {/* общее игровое поле, два окна */}
        <div className="tableS-board-game">
          <div className="tableS-board-wrapper--Type1">
            <RenderCode
              code={code}
              isGameStarted={isGameStarted}
              isGameFinished={isGameFinished}
            />
            <RenderGameCard isGameFinished={isGameFinished}>
              <RenderTable1 table={table} />
            </RenderGameCard>
          </div>

          <div className="tableS-button-input-board">
            <div className="tableS-subtitle">Введи ответ: </div>
            <input
              className={"tableS-input tableS-" + answerStatus}
              disabled={blockUserInput}
              value={answerValue}
              onFocus={() => setAnswerStatus("idle")}
              onChange={handleInputChange}
              onKeyDown={handleInputKeyDown}
            ></input>
            {!blockUserInput && (
              <button
                title="Проверить ответ"
                className="tableS-buttonCheck"
                onClick={() => checkAnswer(answerValue)}
              >
                Проверить
              </button>
            )}
            {blockUserInput && isGameStarted && !isGameFinished && (
              <button className="tableS-buttonCheck" onClick={nextGuessed}>
                Далее
                <img
                  alt=""
                  className="tableS-logoRun"
                  src="/img/button/run-fix.svg"
                />
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BoardType1;
